import React from 'react';
import subscribeNewsBg from '../../../assets/subscribe_news.jpg';

export const NewsletterSubscribe: React.FC = () => {
  return (
    <div
      className="relative w-full overflow-hidden"
      style={{
        backgroundImage: `url(${subscribeNewsBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        marginLeft: 'calc(-50vw + 50%)!important' as any,
        marginRight: 'calc(-50vw + 50%)!important' as any,
        width: '100vw!important' as any
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0" style={{ backgroundColor: '#0000004D' }} />

      {/* Content */}
      <div
        className="relative flex items-center justify-between gap-20"
        style={{
          paddingTop: '112px',
          paddingBottom: '112px',
          paddingLeft: '130px',
          paddingRight: '130px'
        }}
      >
        {/* Left: Text */}
        <div className="flex-1">
          <h2
            style={{
              fontFamily: 'Poppins',
              fontSize: '48px',
              fontWeight: 700,
              lineHeight: '56px',
              color: '#FFFFFF'
            }}
          >
            Register now so you don't miss our NEWS!
          </h2>
        </div>

        {/* Right: Email Input and Button */}
        <div className="flex-1 flex flex-col items-end gap-4">
          <div className="flex gap-4 w-full max-w-md">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-6 py-4 border-none outline-none bg-white"
              style={{
                fontFamily: 'Inter',
                fontSize: '16px',
                fontWeight: 400,
                borderRadius: '10px'
              }}
            />
            <button
              className="px-8 py-4 bg-black text-white"
              style={{
                fontFamily: 'Inter',
                fontSize: '16px',
                fontWeight: 600,
                borderRadius: '10px'
              }}
            >
              Subscribe
            </button>
          </div>
          <p
            style={{
              fontFamily: 'Inter',
              fontSize: '12px',
              fontWeight: 400,
              color: '#FFFFFF'
            }}
          >
            By clicking Sign Up you're confirming that you agree with our{' '}
            <span className="underline cursor-pointer">Terms and Conditions</span>.
          </p>
        </div>
      </div>
    </div>
  );
};
